var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.932 0.721798C9.20347 0.839643 9.36476 1.12236 9.32805 1.41602L8.75506 6L12.885 6C13.0457 5.99997 13.2084 5.99994 13.3414 6.01197C13.4671 6.02336 13.7079 6.05347 13.9167 6.22221C14.1558 6.41539 14.2927 6.70776 14.2881 7.01508C14.284 7.28351 14.153 7.48776 14.0813 7.59165C14.0054 7.70149 13.9012 7.82648 13.7983 7.94989L7.84535 15.0935C7.65589 15.3208 7.33922 15.396 7.06774 15.2782C6.79626 15.1604 6.63497 14.8776 6.67168 14.584L7.24468 10L3.11469 10C2.95402 10 2.7913 10.0001 2.65834 9.98802C2.53261 9.97664 2.29183 9.94652 2.08302 9.77779C1.84397 9.58461 1.70703 9.29223 1.71166 8.98492C1.71571 8.71649 1.84672 8.51224 1.91847 8.40835C1.99433 8.29851 2.09853 8.17352 2.20141 8.05011C2.20651 8.04399 2.2116 8.03788 2.21669 8.03178L8.15439 0.906542C8.34385 0.679186 8.66052 0.603952 8.932 0.721798Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.dcf8484836d81794aa51a43aa32a709e.svg";
export { ForwardRef as ReactComponent };